<template>
  <div class="container is-fluid">
    <div class="box has-background-light">
      <div class="level">
        <div class="level-left">
          <h5 class="title is-5 has-text-primary">Dashboard</h5>
        </div>
        <div class="level-right">
          <button
            class="button is-primary is-rounded is-small"
            @click="processar()"
            :disabled="cmbPeriodoPerfil.estaFechado"
          >
            <span class="icon is-small">
              <i class="fas fa-cog"></i>
            </span>
            <span>Processar</span>
          </button>
        </div>
      </div>

      <form @submit.prevent="filterRecords" class="filter-form">
        <div class="columns is-multiline is-mobile">
          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Tipo de Período</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="cmbTipoPeriodo" @change="selectTipoPeriodo()">
                    <option value="0" disabled>Selecione um tipo de período</option>
                    <option v-for="td in tiposPeriodo" :key="td.id" :value="td.id">
                      {{ td.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Perfil</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="cmbPerfil" @change="selectPerfil()">
                    <option value="0" disabled>Selecione um perfil</option>
                    <option v-for="perfilUsuario in perfisUsuario" :key="perfilUsuario.id" :value="perfilUsuario.perfil.id">
                      {{ perfilUsuario.perfil.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Período</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="cmbPeriodoPerfil" @change="selectPeriodoPerfil()">
                    <option value="0" disabled>Selecione um período</option>
                    <option v-for="periodoPerfil in periodosPerfis" :key="periodoPerfil.id" :value="periodoPerfil">
                      {{ periodoPerfil.periodo.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Grupo de Indicadores</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="cmbGrupoIndicador">
                    <option value="0">TODOS OS GRUPOS DE INDICADORES</option>
                    <option v-for="gi in gruposIndicadores" :key="gi.id" :value="gi.grupo_indicador.id">
                      {{ gi.grupo_indicador.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small"></label>
              <div class="control">
                <button type="submit" class="button is-primary is-rounded is-small">
                  <span class="icon is-small">
                    <i class="fas fa-filter"></i>
                  </span>
                  <span>Filtrar</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal" :class="{ 'is-active': isShowModalAjudar }">
      <div class="modal-background" @click="isShowModalAjudar = false"></div>
      <div class="modal-card">
        <header class="modal-card-head has-background-primary has-text-white">
          <p class="modal-card-title has-text-white">O que é {{ indicadorSelecionado }}?</p>
          <button class="delete" aria-label="close" @click="isShowModalAjudar = false"></button>
        </header>
        <section class="modal-card-body">
          <p>{{ indicadorComentario }}</p>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-primary is-rounded" @click="isShowModalAjudar = false">Fechar</button>
        </footer>
      </div>
    </div>

    <div class="modal" :class="{ 'is-active': isShowModal }">
      <div class="modal-background" @click="isShowModal = false"></div>
      <div class="modal-card is-large">
        <header class="modal-card-head has-background-primary has-text-white">
          <p class="modal-card-title has-text-white">Evolução do {{ indicadorSelecionado }}</p>
          <button class="delete" aria-label="close" @click="isShowModal = false"></button>
        </header>
        <section class="modal-card-body">
          <div v-for="(gih, index) in gruposIndicadoresHistorico" :key="index">
            <div class="card" v-for="(gih2, index2) in gih[1]" :key="index2">
              <header class="card-header has-background-primary has-text-white">
                <p class="card-header-title has-text-white">{{ gih2[0] }}</p>
              </header>
              <div class="card-content">
                <apexchart ref="chartEvolucaoIndicador" height="300" width="100%" type="line" :options="gih2[2]" :series="gih2[3]"></apexchart>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-primary is-rounded" @click="isShowModal = false">Fechar</button>
        </footer>
      </div>
    </div>

    <div v-if="showInfo">
      <div class="columns is-multiline">
        <div class="column is-half" v-for="(gip, index) in gruposIndicadoresPeriodo" :key="index">
          <div class="card">
            <header class="card-header has-background-primary has-text-white">
              <p class="card-header-title has-text-white">{{ index }}</p>
              <a
                v-if="gip[0].indicador.grupo_indicador.comentario"
                class="card-header-icon has-text-white"
                @click="showComentario(index)"
                title="Ver comentário do grupo"
              >
                <span class="icon">
                  <i class="fas fa-question-circle"></i>
                </span>
              </a>
            </header>
            <div v-if="comentarioAtivo === index" class="notification is-success is-light mt-1 mb-0 py-2 px-3">
              <button class="delete is-small" @click="comentarioAtivo = null"></button>
              <span class="is-size-7">{{ gip[0].indicador.grupo_indicador.comentario }}</span>
            </div>
            <div class="card-content">
              <div class="table-container">
                <table class="table is-fullwidth is-narrow is-striped is-hoverable">
                  <thead>
                    <tr class="has-background-grey-lighter">
                      <th class="is-size-7">Indicador</th>
                      <th class="is-size-7 has-text-centered">Ajuda</th>
                      <th class="is-size-7 has-text-centered">Evolução</th>
                      <th class="is-size-7 has-text-right">{{ anoMesReferencia | datePorTipo(cmbTipoPeriodo) }}</th>
                      <th class="is-size-7 has-text-centered">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in gip" :key="item.id">
                      <td class="is-size-7" v-if="item.indicador.dashboard">{{ item.indicador.descricao }}</td>
                      <td class="is-size-7 has-text-centered" v-if="item.indicador.dashboard">
                        <button class="button is-ghost is-small" @click="callHelp(item.indicador)" title="Comentários">
                          <span class="icon is-small">
                            <i class="fas fa-question-circle"></i>
                          </span>
                        </button>
                      </td>
                      <td class="is-size-7 has-text-centered" v-if="item.indicador.dashboard">
                        <button class="button is-ghost is-small" @click="callChart(item.indicador)" title="Evolução">
                          <span class="icon is-small">
                            <i class="fas fa-chart-line"></i>
                          </span>
                        </button>
                      </td>
                      <td class="is-size-7 has-text-right" v-if="item.indicador.dashboard">{{ item.valor | numberFormat }}</td>
                      <td class="is-size-7 has-text-centered" v-if="item.indicador.dashboard && item.valor_referencia_indicador == null">Nenhum</td>
                      <td class="is-size-7 has-text-centered has-background-danger-dark has-text-white-bis" v-if="item.indicador.dashboard && item.valor_referencia_indicador != null && item.valor_referencia_indicador.status == '1'">Péssimo</td>
                      <td class="is-size-7 has-text-centered has-background-danger-light" v-if="item.indicador.dashboard && item.valor_referencia_indicador != null && item.valor_referencia_indicador.status == '2'">Ruim</td>
                      <td class="is-size-7 has-text-centered has-background-warning-light" v-if="item.indicador.dashboard && item.valor_referencia_indicador != null && item.valor_referencia_indicador.status == '3'">Normal</td>
                      <td class="is-size-7 has-text-centered has-background-success-light" v-if="item.indicador.dashboard && item.valor_referencia_indicador != null && item.valor_referencia_indicador.status == '4'">Bom</td>
                      <td class="is-size-7 has-text-centered has-background-success-dark has-text-white-bis" v-if="item.indicador.dashboard && item.valor_referencia_indicador != null && item.valor_referencia_indicador.status == '5'">Excelente</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box has-background-light" v-if="graficos.length">
        <h6 class="title is-6 has-text-primary">Gráficos</h6>
        <div class="columns is-multiline">
          <div class="column is-full" v-for="(g, index) in graficos" :key="index">
            <div class="card">
              <header class="card-header has-background-primary has-text-white">
                <p class="card-header-title has-text-white">{{ g.nomeGrafico }}</p>
              </header>
              <div class="card-content">
                <apexchart :type="g.type" height="350" width="100%" :options="g.options[0]" :series="g.type === 'pie' ? g.series : g.series[0]"></apexchart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { http } from '../../services/config';
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'IndicadorPeriodo',
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      periodosPerfis: [],
      perfisUsuario: [],
      gruposIndicadores: [],
      gruposIndicadoresPeriodo: [],
      gruposIndicadoresHistorico: [],
      graficos: [],
      indicadoresPeriodo: [],
      tiposPeriodo: [],
      cmbPerfil: 0,
      cmbPeriodoPerfil: 0,
      cmbGrupoIndicador: 0,
      cmbTipoPeriodo: 0,
      anoMesReferencia: '',
      anoMesMesAnteriorReferencia: '',
      anoMesAnoAnteriorReferencia: '',
      anoMes3AnosAnteriorReferencia: '',
      anoMes5AnosAnteriorReferencia: '',
      anoMes10AnosAnteriorReferencia: '',
      indicadorSelecionado: '',
      indicadorComentario: '',
      showInfo: false,
      isShowModal: false,
      comentarioAtivo: null,
      comentarioVisivel: null,
      isShowModalAjudar: false,
    };
  },
  methods: {
    showComentario(index) {
      this.comentarioAtivo = this.comentarioAtivo === index ? null : index;
    },
    callHelp(ind) {
      this.isShowModalAjudar = true;
      this.indicadorSelecionado = ind.descricao.substring(0, 25) + '?';
      this.indicadorComentario = ind.comentario;
    },
    filterRecords() {
      if (this.cmbTipoPeriodo == 0) {
        alert('Selecione um tipo de período');
        return;
      }
      if (this.cmbPerfil == 0) {
        alert('Selecione um perfil');
        return;
      }
      if (this.cmbPeriodoPerfil == 0) {
        alert('Selecione um período');
        return;
      }
      http.get('indicadorPeriodo/listar/', {
        params: {
          idPeriodoPerfil: this.cmbPeriodoPerfil.id,
          idGrupoIndicador: this.cmbGrupoIndicador,
        },
      }).then((response) => {
        this.gruposIndicadoresPeriodo = _.groupBy(response.data.results, (x) => x.indicador.grupo_indicador.descricao);
        if (Object.keys(this.gruposIndicadoresPeriodo).length) {
          this.showInfo = true;
          http.get('grafico/graficosPeriodo/', {
            params: { idPeriodoPerfil: this.cmbPeriodoPerfil.id },
          }).then((response) => {
            let typeChart;
            let seriesGrafico;
            let groupByIndicadores;
            let seriesDescIndicadores;
            let seriesValorIndicadores;
            let categoriesGrafico = Object.keys(_.groupBy(response.data.results, (x) => x.desc_periodo));
            let descGraficos = Object.keys(_.groupBy(response.data.results, (x) => x.tipo_grafico + '-' + x.desc_grafico));
            let arrayGraficos = Object.values(_.groupBy(response.data.results, (x) => x.tipo_grafico + '-' + x.desc_grafico));
            this.graficos = [];
            for (let index = 0; index < descGraficos.length; index++) {
              if (descGraficos[index].substring(0, 1) == '1') {
                typeChart = 'pie';
                this.graficos.push({
                  nomeGrafico: descGraficos[index].substring(2),
                  series: [],
                  options: [{
                    chart: { width: 1000, type: 'pie' },
                    labels: [],
                    responsive: [{
                      breakpoint: 1000,
                      options: {
                        chart: { width: 350 },
                        legend: { position: 'bottom' },
                      },
                    }],
                  }],
                  type: typeChart,
                });
              } else if (descGraficos[index].substring(0, 1) == '2') {
                typeChart = 'bar';
                this.graficos.push({
                  nomeGrafico: descGraficos[index].substring(2),
                  series: [],
                  options: [{
                    chart: { type: 'bar', height: 350 },
                    plotOptions: { bar: { horizontal: false, columnWidth: '15%', borderRadius: 5, borderRadiusApplication: 'end' } },
                    dataLabels: { enabled: false },
                    stroke: { show: true, width: 2, colors: ['transparent'] },
                    xaxis: { categories: categoriesGrafico },
                    fill: { opacity: 1 },
                    tooltip: { y: { formatter: (val) => 'R$ ' + val } },
                  }],
                  type: typeChart,
                });
              } else {
                typeChart = 'area';
                this.graficos.push({
                  nomeGrafico: descGraficos[index].substring(2),
                  series: [],
                  options: [{
                    chart: { height: 350, type: 'area' },
                    dataLabels: { enabled: false },
                    stroke: { curve: 'smooth' },
                    markers: { size: 1 },
                    legend: { position: 'top', horizontalAlign: 'right', floating: true, offsetY: -25, offsetX: -5 },
                    xaxis: { type: 'string', categories: categoriesGrafico },
                  }],
                  type: typeChart,
                });
              }
            }
            for (let index = 0; index < arrayGraficos.length; index++) {
              if (this.graficos[index].type != 'pie') {
                groupByIndicadores = _.groupBy(arrayGraficos[index], (x) => x.desc_indicador);
                seriesDescIndicadores = Object.keys(groupByIndicadores);
                seriesValorIndicadores = Object.values(groupByIndicadores);
                seriesGrafico = [];
                for (let i = 0; i < seriesDescIndicadores.length; i++) {
                  seriesGrafico.push({ name: seriesDescIndicadores[i], data: [] });
                }
                for (let i = 0; i < seriesValorIndicadores.length; i++) {
                  for (let j = 0; j < seriesValorIndicadores[i].length; j++) {
                    seriesGrafico[i].data.push(seriesValorIndicadores[i][j].valor_kpi.toFixed(2));
                  }
                }
                this.graficos[index].series.push(seriesGrafico);
              } else {
                this.graficos[index].series = [];
                this.graficos[index].options[0].labels = [];
                for (let j = 0; j < arrayGraficos[index].length; j++) {
                  this.graficos[index].series.push(arrayGraficos[index][j].valor_kpi);
                  this.graficos[index].options[0].labels.push(arrayGraficos[index][j].desc_indicador);
                }
              }
            }
          });
        } else {
          this.showInfo = false;
          alert('Não há dados associados aos parâmetros informados!');
        }
      });
    },
    selectTipoPeriodo() {
      this.cmbPerfil = 0;
      this.cmbPeriodoPerfil = 0;
      this.cmbGrupoIndicador = 0;
      this.indicadoresPeriodo = [];
      this.anoMesReferencia = '';
      this.anoMesMesAnteriorReferencia = '';
      this.anoMesAnoAnteriorReferencia = '';
      this.anoMes3AnosAnteriorReferencia = '';
      this.anoMes5AnosAnteriorReferencia = '';
      this.anoMes10AnosAnteriorReferencia = '';
      this.showInfo = false;
    },
    selectPerfil() {
      http.get('periodoPerfil/listar/', {
        params: {
          idPerfil: this.cmbPerfil,
          idTipoPeriodo: this.cmbTipoPeriodo,
          semPaginacao: 'S',
        },
      }).then((response) => {
        this.periodosPerfis = response.data.results;
        if (!this.periodosPerfis.length) {
          alert('Não há períodos associados ao perfil selecionado!');
          this.cmbPeriodoPerfil = 0;
        }
      });
    },
    selectPeriodoPerfil() {
      http.get('grupoIndicador/listarGruposIndicadores/', {
        params: { idVersaoPlanoContas: this.cmbPeriodoPerfil.versao_plano_contas.id },
      }).then((response) => {
        this.gruposIndicadores = response.data.results;
        this.anoMesReferencia = this.cmbPeriodoPerfil.periodo.data;
        this.anoMesMesAnteriorReferencia = this.cmbPeriodoPerfil.periodo.data_mes_anterior;
        this.anoMesAnoAnteriorReferencia = this.cmbPeriodoPerfil.periodo.data_ano_anterior;
        this.anoMes3AnosAnteriorReferencia = this.cmbPeriodoPerfil.periodo.data_3anos_anteriores;
        this.anoMes5AnosAnteriorReferencia = this.cmbPeriodoPerfil.periodo.data_5anos_anteriores;
        this.anoMes10AnosAnteriorReferencia = this.cmbPeriodoPerfil.periodo.data_10anos_anteriores;
        if (!this.gruposIndicadores.length) {
          alert('Não há grupos de indicadores associados a versão associada ao período selecionado!');
          this.cmbGrupoIndicador = 0;
        } else {
          this.filterRecords();
        }
      });
    },
    callChart(ind) {
      this.isShowModal = true;
      this.indicadorSelecionado = ind.descricao.substring(0, 40);
      http.get('indicadorPeriodo/historico/', {
        params: {
          idPeriodoPerfil: this.cmbPeriodoPerfil.id,
          idGrupoIndicador: this.cmbGrupoIndicador,
          idIndicador: ind.id,
        },
      }).then((response) => {
        let auxGrupoIndicador = null;
        let auxIndicador = null;
        // let auxPeriodoValor = [];
        let nIndGI, nIndI;
        this.gruposIndicadoresHistorico = [];
        for (let i = 0; i < response.data.results.length; i++) {
          if (auxGrupoIndicador == null || response.data.results[i].grupoIndicador != auxGrupoIndicador) {
            auxGrupoIndicador = response.data.results[i].grupoIndicador;
            auxIndicador = null;
            // auxPeriodoValor = [];
            this.gruposIndicadoresHistorico.push([auxGrupoIndicador, []]);
            nIndGI = this.gruposIndicadoresHistorico.length - 1;
          }
          if (auxIndicador == null || response.data.results[i].kpi != auxIndicador) {
            auxIndicador = response.data.results[i].kpi;
            // auxPeriodoValor = [];
            let seriesEvolucaoIndicadores = [{ name: 'Indicador', data: [] }];
            let options = {
              chart: { id: 'accounting-evolucao' },
              xaxis: {
                categories: [],
                labels: { style: { fontSize: '10px' }, show: true },
              },
              dataLabels: { enabled: false },
              plotOptions: { bar: { horizontal: false, columnWidth: '55%', endingShape: 'rounded' } },
              markers: { size: 4 },
            };
            this.gruposIndicadoresHistorico[nIndGI][1].push([auxIndicador, [], options, seriesEvolucaoIndicadores, response.data.results[i].comentarioKPI]);
            nIndI = this.gruposIndicadoresHistorico[nIndGI][1].length - 1;
          }
          this.gruposIndicadoresHistorico[nIndGI][1][nIndI][1].push([response.data.results[i].periodo, parseFloat(response.data.results[i].valorKPI).toFixed(2)]);
        }
        for (let i = 0; i < this.gruposIndicadoresHistorico.length; i++) {
          for (let j = 0; j < this.gruposIndicadoresHistorico[i][1].length; j++) {
            for (let k = 0; k < this.gruposIndicadoresHistorico[i][1][j][1].length; k++) {
              this.gruposIndicadoresHistorico[i][1][j][2].xaxis.categories.push(this.gruposIndicadoresHistorico[i][1][j][1][k][0]);
              this.gruposIndicadoresHistorico[i][1][j][3][0].data.push(this.gruposIndicadoresHistorico[i][1][j][1][k][1]);
            }
          }
        }
      });
    },
    processar() {
      if (this.cmbPerfil == 0) {
        alert('Perfil não selecionado!');
        return;
      }
      if (this.cmbPeriodoPerfil == 0) {
        alert('Período não selecionado!');
        return;
      }
      if (window.confirm('Confirma o processamento dos indicadores no período informado?')) {
        http.put('/indicadorPeriodo/processar/' + this.cmbPeriodoPerfil.id, this.cmbGrupoIndicador).then((response) => {
          if (response.status == 204) {
            this.filterRecords();
            alert('Processamento concluído!');
          }
        }).catch((e) => {
          console.log(e);
          alert('Erro ao processar os indicadores.');
        });
      }
    },
  },
  mounted() {},
  created() {
    http.get('compartilharPerfis/listarPerfis').then((response) => {
      this.perfisUsuario = response.data.results;
    });
    http.get('tiposPeriodo/listar').then((response) => {
      this.tiposPeriodo = response.data.results;
    });
  },
};
</script>

<style scoped>
</style>